import { type LayoutPages } from '../../types';
import EmbeddedDrawerShell from '../../../components/embedded/DrawerShell';
import HostedDesktopAppInstallPage from '../../hosted/desktop/DesktopAppInstallPage';
import EmbeddedLoadingPage from '../shared/LoadingPage';
import EmbeddedSpinnerScreen from '../shared/SpinnerScreen';
import EmbeddedAppPickerPage from '../shared/AppPickerPage';
import EmbeddedAppPairingPage from '../shared/AppPairingPage';
import EmbeddedDonePage from '../shared/DonePage';
import EmbeddedMobileAgentStartPage from './MobileAgentStartPage';
import EmbeddedMobileWaitingPage from './MobileWaitingPage';
import EmbeddedMobileAbortPage from './MobileAbortPage';

/** The embedded drawer over the website's page, on phones (not tablets). */
export const embeddedMobilePages: LayoutPages = {
  Shell: EmbeddedDrawerShell,
  // The app list's placeholder tiles, then a spinner once an app is chosen.
  Loading: EmbeddedLoadingPage,
  Init: EmbeddedSpinnerScreen,
  Auth: EmbeddedSpinnerScreen,
  AppPicker: EmbeddedAppPickerPage,
  AgentStart: EmbeddedMobileAgentStartPage,
  AppPairing: EmbeddedAppPairingPage,
  WaitingForPresentation: EmbeddedMobileWaitingPage,
  Done: EmbeddedDonePage,
  Abort: EmbeddedMobileAbortPage,
  // Only reached through ?app= on a top-level page, never inside the iframe.
  AppInstall: HostedDesktopAppInstallPage,
};
